import React from "react";
import FlexTable from "./flex-table";
import ResponsiveFlexTable from "./responsive-flex-table";

const ResponsiveTableWrapper = props =>
  props.showResponsive ? <ResponsiveFlexTable {...props} /> : <FlexTable {...props} />;

export default ResponsiveTableWrapper;
